import { useEffect, useMemo, useState } from 'react';
import jwtDecode from 'jwt-decode';

import { EnvUtils } from '@/utils/env.utils';
import { getURLParams } from '@/utils/URLParams.utils';
import { getAccessToken } from './token.utils';
import { appInsights } from '@/services/Telemetry/AppInsights.service';
import { ExceptionTypes } from '@/config/LogEventTypes.config';
import { notificationService } from '@/services/notification/notification.client';
import { DEFAULT_ERROR_MESSAGE } from '@/config/text.const';

export async function getOrganisationId() {
  if (EnvUtils.isDevelopment()) {
    return getURLParams(window.location.href)?.organisationid;
  }

  try {
    const tokenString = await getAccessToken();
    const parsedToken = jwtDecode<{ org_id: string }>(tokenString);
    const orgId = parsedToken.org_id ?? 'test';
    return orgId;
  }
  catch (err: any) {
    appInsights.trackException({ error: new Error(err?.message) }, {
      exceptionType: ExceptionTypes.AUTH_EXCEPTION,
      pageUrl: window.location.href,
    });

    notificationService.open({
      title: 'Error',
      text: err?.message ?? DEFAULT_ERROR_MESSAGE,
      type: 'danger'
    });
    return null;
  }
}

export function useOrganisationId() {
  const [isLoading, setIsLoading] = useState(true);
  const [organisationId, setOrganisationId] = useState<string | null>(null);

  useEffect(() => {
    getOrganisationId().then((id) => {
      setOrganisationId(id);
      setIsLoading(false);
    });
  }, []);

  return useMemo(() => ({
    isLoading,
    organisationId,
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [isLoading, organisationId]);
}